<template>
  <Left__WP_Drawer />
  <Right__WP_Drawer />

  <MainArea__WP_View />
</template>

<script>
  import 'vue-cal/dist/vuecal.css'
  import Left__WP_Drawer from "@/components/wp_planner/drawers/left.drawer.vue"
  import Right__WP_Drawer from "@/components/wp_planner/drawers/right.drawer.vue"
  import MainArea__WP_View from "@/components/wp_planner/main.area.vue"
  import { UserStore } from "@/store/GigaUser"
  import { TokenGUIDStore } from "@/store/global/SessionStore"
  import { CurrentPeriod } from "@/store/wp_planner/main.store"
  import { Reg_Documents } from "@/store/wp_planner/documents.store"
  import { Specialists, WeekDura } from "@/store/wp_planner/specialists.store"
  import { District__Info } from "@/store/global/districts.dictionary"
  import { update_all } from "@/libs/wp/update_registered"
  import moment from "moment"
  import { LoadedWeeks, Observers } from "@/store/wp_planner/misc.store";

  export default {
    name: "EditorView",
    components: {
      MainArea__WP_View,
      Right__WP_Drawer,
      Left__WP_Drawer
    },
    async beforeMount() {
      await this.get_data()
    },
    watch: {
      async current_period(value) {
        await this.get_data()
        if (!this.loaded_weeks.includes(value.format('YYYY-MM-DD'))) {
          this.loaded_weeks.push(value.format('YYYY-MM-DD'))
        }
      },
      async district() {
        await this.get_data()
      }
    },
    methods: {
      get_data: async function () {
        await update_all(
            this.session_token,
            this.$route.params.district,
            moment(this.current_period).year(),
            moment(this.current_period).week()
        )

        await this.get_specialists()
        await this.get_observers()
      },
      get_observers: async function () {
        let url = `${this.$config.SSL}://${this.$config.ONEADDRESS}/${this.$config.BASE}/${this.$config.API_VERSION}/wp/observers/get`
        let raw = {
          year: this.current_period.year(),
          week: this.current_period.week(),
          district: this.$route.params.district,
        }

        let properies = {
          method: 'POST',
          withCredentials: true,
          headers: {
            "Authorization": "Bearer " + this.session_token
          },
          body: JSON.stringify(raw)
        }
        await fetch(url, properies)
            .then(async response => {
              if (response.ok) {
                return await response.json()
              } else {
                throw `Ошибка получения дежурных!`
              }
            })
            .then(result => {
              this.observers = []
              for (let observer of result) {
                let day = this.observers.find(el => el.day === observer.day)
                if (!day) {
                  this.observers.push(observer)
                }
              }
            }).catch(err => {
              console.error(err)
            })
      },
      get_specialists: async function () {
        this.specialists = null
        let url = `${this.$config.SSL}://${this.$config.ONEADDRESS}/${this.$config.BASE}/${this.$config.API_VERSION}/WP_GetWorkers`
        let raw = {
          year: this.current_period.year(),
          week: this.current_period.week(),
          district: this.$route.params.district,
        }

        let properies = {
          method: 'POST',
          withCredentials: true,
          headers: {
            "Authorization": "Bearer " + this.session_token
          },
          body: JSON.stringify(raw)
        }
        await fetch(url, properies)
            .then(async response => {
              if (response.ok) {
                return await response.json()
              } else {
                throw `Ошибка получения сотрудников!`
              }
            })
            .then(result => {
              this.specialists = result.specialists
              this.week_ext_data = result.week
            }).catch(err => {
              console.error(err)
            })
      },
    },
    computed: {
      district: {
        get() {
          return District__Info().get()
        },
        set(value) {
          District__Info().set(value)
        }
      },
      loaded_weeks: {
        get() {
          return LoadedWeeks().get()
        },
        set(value) {
          LoadedWeeks().set(value)
        }
      },
      user: {
        get() {
          return UserStore().get()
        },
        set(value) {
          UserStore().set(value)
        }
      },
      specialists: {
        get() {
          return Specialists().get()
        },
        set(value) {
          Specialists().set(value)
        }
      },
      week_ext_data: {
        get() {
          return WeekDura().get()
        },
        set(value) {
          WeekDura().set(value)
        }
      },
      observers: {
        get() {
          return Observers().get()
        },
        set(value) {
          Observers().set(value)
        }
      },
      current_period: {
        get() {
          return CurrentPeriod().get()
        },
        set(value) {
          CurrentPeriod().set(value)
        }
      },
      docs__registered: {
        get() {
          return Reg_Documents().get()
        },
        set(value) {
          Reg_Documents().set(value)
        }
      },
      session_token() {
        return TokenGUIDStore().get()
      },
    }
  }
</script>

<style>
.vuecal__now-line { color: #0c9d18; }
</style>
